/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.css";
import Slider from "react-slick";
import PropTypes from "prop-types";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { getCDPAltText } from "../../../utils/helpers/get-cdp-alt-text";
import VideoGallerySliderModal from "../video-gallery-slider-modal";
import { NUMBER, PAGE_SOURCE } from "../../../constants/app-constants";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";
import CarUspContainer from "../car-usp-container";
import { GALLERY_TAB_TYPE } from "../car-detail-info/constant";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { VIDEO_TOUR_ICON } from "../../../constants/image-url-constant";
import VideoIcon from "./images/videoIcon.svg";

// eslint-disable-next-line no-unused-vars
const VideoCatalogCdpHeroslider = ({
    content = {},
    openGalleryPopUp,
    config,
    calculatorRef,
    scrollToSection,
    isFetchingOrderDetails,
    isKbbShown,
    handleKbbModal,
    ctaProps,
    setVideoGalleryModalOpenConnect,
    step,
    desktopPremiumFeatures,
    hideImperfectionsDesktop
}) => {
    const {
        exteriorImages = [],
        interiorImages = [],
        imperfectionImages = [],
        threeSixtyViewUrl,
        highlightsGallery = [],
        mainImage
    } = content;

    const {
        carFullName
    } = getCarInfo(content, config) || {};
    const { imageHost, brandImageHost } = config || {};
    const [showVideoGalleryModal, setShowVideoGalleryModal] = useState(false);
    const [activeIndex, setActiveIndex] = useState(NUMBER.ZERO);
    const [carTourIndex, setCarTourIndex] = useState(0);
    // The chapter the tour slider mounts on. Kept apart from carTourIndex because react-slick
    // re-initialises its track whenever a primitive prop changes, which cuts the slide animation.
    const [carTourStartChapter, setCarTourStartChapter] = useState(0);
    const carTourSliderRef = useRef();
    const programmaticCarTourTarget = useRef(null);
    const programmaticGalleryTarget = useRef(null);
    const desktopPremiumFeaturesVariant = getAbExpirementVariant(desktopPremiumFeatures, EXPERIMENT_TYPE.VARIANT_B);
    // Tabs: 'threeSixty', 'carTour', 'allImages', 'imperfections'
    const [activeTab, setActiveTab] = useState(desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.exterior);
    const hideImperfections = getAbExpirementVariant(hideImperfectionsDesktop, EXPERIMENT_TYPE.VARIANT_B);
    const exteriorImgGallery = (exteriorImages || []).map((image, index) => ({ ...image, tabName: "Exterior", key: desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.exterior, imageIndex: index }));
    const interiorImgGallery = (interiorImages || []).map((image, index) => ({ ...image, tabName: "Interior", key: desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.interior, imageIndex: index }));
    const defectImgGallery = (imperfectionImages || []).map((image, index) => ({ ...image, tabName: "Imperfections", key: GALLERY_TAB_TYPE.imperfections, imageIndex: index }));
    const highlightsImgGallery = (highlightsGallery || []).map((image, index) => ({ ...image, tabName: "Highlights", key: GALLERY_TAB_TYPE.highlights, imageIndex: index }));
    // Only include highlights in gallery if the highlights tab is visible
    const showHighlights = desktopPremiumFeaturesVariant;
    const gallery = [...exteriorImgGallery, ...interiorImgGallery, ...(showHighlights ? highlightsImgGallery : []), ...defectImgGallery];
    // The car tour sits between the images and the imperfections, i.e. at the index the imperfections start at
    const firstImperfectionIndex = exteriorImages.length + interiorImages.length + (showHighlights ? highlightsGallery.length : 0);
    const hasImperfections = firstImperfectionIndex < gallery.length;
    const defaultGalleryTab = desktopPremiumFeaturesVariant ? GALLERY_TAB_TYPE.allImages : GALLERY_TAB_TYPE.exterior;
    const galleryTabAfterCarTour = hasImperfections ? GALLERY_TAB_TYPE.imperfections : defaultGalleryTab;
    const beforeCarTourIndex = Math.max((hasImperfections ? firstImperfectionIndex : gallery.length) - 1, 0);
    const galleryTabBeforeCarTour = gallery[beforeCarTourIndex]?.key || defaultGalleryTab;
    const carTourChapterCount = (content?.carTourData?.chapters || []).length;
    const lastCarTourChapterIndex = Math.max(carTourChapterCount - 1, 0);
    // With two chapters or fewer a wrap is indistinguishable from an ordinary move between
    // chapters, so the tour is only left by the tabs in that case
    const canDetectCarTourWrap = carTourChapterCount > NUMBER.TWO;
    // Without imperfections the tour sits where the gallery wraps round. With two images or fewer
    // a wrap is indistinguishable from an ordinary move, so it is only reached by its tab then.
    const canDetectGalleryWrap = gallery.length > NUMBER.TWO;
    // Entered by scrolling forward on to the first imperfection image, or past the last image when the car has none
    const isCarTourEntryForward = (oldIndex, newIndex) => (hasImperfections
        ? oldIndex === firstImperfectionIndex - 1 && newIndex === firstImperfectionIndex
        : canDetectGalleryWrap && oldIndex === gallery.length - 1 && newIndex === 0);
    // ...and by scrolling back off the first imperfection image, or back past the first image when the
    // car has none - either way it opens on its last chapter
    const isCarTourEntryBackward = (oldIndex, newIndex) => (hasImperfections
        ? oldIndex === firstImperfectionIndex && newIndex === firstImperfectionIndex - 1
        : canDetectGalleryWrap && oldIndex === 0 && newIndex === gallery.length - 1);
    const [pendingScrollIndex, setPendingScrollIndex] = useState(-1);

    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();

    // react-slick defers slickGoTo to a timeout, so a scroll we asked for is recognised by its
    // target index when it reaches beforeChange - only user navigation may enter or leave the tour
    const scrollGalleryTo = (index) => {
        if (!nav1) {
            return;
        }
        programmaticGalleryTarget.current = index;
        nav1.slickGoTo(index);
    };
    const scrollCarTourTo = (index) => {
        if (!carTourSliderRef.current) {
            return;
        }
        programmaticCarTourTarget.current = index;
        carTourSliderRef.current.slickGoTo(index);
    };
    // Reads and clears the pending target, so it can only ever match the scroll that set it
    const isRequestedScroll = (targetRef, newIndex) => {
        const isRequested = targetRef.current === newIndex;
        targetRef.current = null;
        return isRequested;
    };

    /**
     * This function is used to get the image category by index and tab name.
     * If tabName is provided, it will return true if the image category is the same as the tabName, otherwise it will return the image category.
     * If tabName is not provided, it will return the image category.
     */

    const getImageCategoryByIndex = (index, tabName) => {
        const exteriorImagesLength = exteriorImages?.length;
        const interiorImagesLength = interiorImages?.length;
        const highlightsImagesLength = highlightsGallery?.length;
        const imperfectionImagesLength = imperfectionImages?.length;

        let type;

        if (index < exteriorImagesLength) {
            type = GALLERY_TAB_TYPE.exterior;
        } else if (index < exteriorImagesLength + interiorImagesLength) {
            type = GALLERY_TAB_TYPE.interior;
        } else if (index < exteriorImagesLength + interiorImagesLength + highlightsImagesLength) {
            type = GALLERY_TAB_TYPE.highlights;
        } else if (index < exteriorImagesLength + interiorImagesLength + highlightsImagesLength + imperfectionImagesLength) {
            type = GALLERY_TAB_TYPE.imperfections;
        }

        if (tabName) {
            return tabName === type;
        }
        return type;
    };

    // Map tab to gallery type
    const handleHelloArTabClick = (tabName, index) => {
        if (!openGalleryPopUp) return;
        const imageCategory = getImageCategoryByIndex(index);
        if (imageCategory) {
            openGalleryPopUp(imageCategory, index, imageCategory);
        } else {
            openGalleryPopUp(threeSixtyViewUrl ? GALLERY_TAB_TYPE.threeSixtyView : GALLERY_TAB_TYPE.exterior, 0);
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === GALLERY_TAB_TYPE.carTour) {
            setCarTourStartChapter(0);
            setCarTourIndex(0);
            scrollCarTourTo(0);
        } else if (tab === GALLERY_TAB_TYPE.allImages) {
            // Start from beginning
            window.setTimeout(() => {
                scrollGalleryTo(0);
            }, 0);
        } else if (tab === GALLERY_TAB_TYPE.highlights) {
            const highlightsIndex = exteriorImages.length + interiorImages.length;
            setPendingScrollIndex(highlightsIndex);
            window.setTimeout(() => {
                scrollGalleryTo(highlightsIndex);
            }, NUMBER.TEN);
        } else if (tab === GALLERY_TAB_TYPE.exterior) {
            window.setTimeout(() => {
                scrollGalleryTo(0);
            }, 0);
        } else if (tab === GALLERY_TAB_TYPE.interior) {
            const firstInteriorImageIndex = exteriorImages.length;
            setPendingScrollIndex(firstInteriorImageIndex);
            window.setTimeout(() => {
                scrollGalleryTo(firstInteriorImageIndex);
            }, NUMBER.TEN);
        } else if (tab === GALLERY_TAB_TYPE.imperfections) {
            if (imperfectionImages.length === 0) {
                openGalleryPopUp(GALLERY_TAB_TYPE.allImages, 0, GALLERY_TAB_TYPE.imperfections);
                return;
            }
            // Jump to first imperfection image
            setPendingScrollIndex(firstImperfectionIndex);
            window.setTimeout(() => {
                scrollGalleryTo(firstImperfectionIndex);
            }, NUMBER.TEN);

        } else {
            handleHelloArTabClick(tab);
        }
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.CDP_TAB_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.CDP_TAB_SELECTED,
            eventLabel: content.appointmentId,
            eventAction: tab
        });
    };
    useEffect(() => {
        if (pendingScrollIndex !== -1) {
            if (nav1) {
                programmaticGalleryTarget.current = pendingScrollIndex;
                nav1.slickGoTo(pendingScrollIndex);
                setPendingScrollIndex(-1);
            }
        }
    }, [nav1, pendingScrollIndex]);

    const settingsSlider1 = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: true,
        lazyLoad: "ondemand",
        asNavFor: nav2,
        ref: slider1 => setNav1(slider1),
        beforeChange: (oldIndex, newIndex) => {
            const isUserNavigation = !isRequestedScroll(programmaticGalleryTarget, newIndex);
            if (isUserNavigation && (isCarTourEntryForward(oldIndex, newIndex) || isCarTourEntryBackward(oldIndex, newIndex))) {
                // Entering backwards opens the tour on its last chapter. The slider is mounted
                // fresh on entry, so let initialSlide place it rather than scrolling it there.
                const chapterIndex = isCarTourEntryBackward(oldIndex, newIndex) ? lastCarTourChapterIndex : 0;
                setCarTourStartChapter(chapterIndex);
                setCarTourIndex(chapterIndex);
                setActiveTab(GALLERY_TAB_TYPE.carTour);
                return;
            }
            // check if current image index is one less than highlight image index
            if (newIndex === exteriorImages.length + interiorImages.length && desktopPremiumFeaturesVariant) {
                setActiveTab(GALLERY_TAB_TYPE.highlights);
            }
            // going back from highlight to all images
            if (newIndex <= (exteriorImages.length + interiorImages.length - 1)) {
                if (desktopPremiumFeaturesVariant) {
                    setActiveTab(GALLERY_TAB_TYPE.allImages);
                }
            }
            // check for defects
            if (newIndex === exteriorImages?.length + interiorImages?.length + highlightsGallery?.length) {
                setActiveTab(GALLERY_TAB_TYPE.imperfections);
            }
        },
        afterChange: (index) => {
            // A requested scroll dropped mid-animation never reaches beforeChange, so don't let it linger
            programmaticGalleryTarget.current = null;
            setActiveIndex(index);
        }
    };

    const settingsSlider2 = {
        swipeToSlide: true,
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        arrow: false,
        dots: false,
        asNavFor: nav1,
        ref: slider2 => setNav2(slider2)
    };

    const carTourSliderSettings = {
        initialSlide: carTourStartChapter,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,  // Fix: change from 'arrow' to 'arrows'
        dots: false,
        centerMode: true,
        centerPadding: "10px",
        infinite: true,
        afterChange: (index) => {
            programmaticCarTourTarget.current = null;
            setCarTourIndex(index);
        },
        beforeChange: (oldIndex, newIndex) => {
            // Only the user wrapping off either end leaves the tour, never a jump we asked for
            const isWrap = canDetectCarTourWrap && !isRequestedScroll(programmaticCarTourTarget, newIndex);
            if (isWrap && oldIndex === lastCarTourChapterIndex && newIndex === 0) {
                setActiveTab(galleryTabAfterCarTour);
                setPendingScrollIndex(hasImperfections ? firstImperfectionIndex : 0);
            } else if (isWrap && oldIndex === 0 && newIndex === lastCarTourChapterIndex) {
                setActiveTab(galleryTabBeforeCarTour);
                setPendingScrollIndex(beforeCarTourIndex);
            } else {
                setCarTourIndex(newIndex);
                trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.DESKTOP_VIDEO_SNIPPET_SCROLLED, {
                    ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.DESKTOP_VIDEO_SNIPPET_SCROLLED,
                    eventLabel: content.appointmentId,
                    eventAction: "app_id"
                });
            }
        }
    };

    // Imperfections
    const imperfectionCount = imperfectionImages.length;

    const openThreeSixtyView = (index) => {
        handleHelloArTabClick(activeTab, index);
    };

    const handleThumbnailClick = (index) => {
        setCarTourIndex(index);
        scrollCarTourTo(index);
        setVideoGalleryModalOpenConnect(true);
        setShowVideoGalleryModal(true);
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.DESKTOP_VIDEO_CHAPTER_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.DESKTOP_VIDEO_CHAPTER_SELECTED,
            eventLabel: content.appointmentId,
            eventAction: "app_id"
        });
    };
    const handleCarTourNudgeClick = (e, idx) => {
        e.preventDefault();
        e.stopPropagation();
        if (carTourIndex !== idx) {
            setCarTourIndex(idx);
            scrollCarTourTo(idx);
        } else {
            setVideoGalleryModalOpenConnect(true);
            setShowVideoGalleryModal(true);
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CATALOGUE_ENTERED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CATALOGUE_ENTERED,
                eventLabel: PAGE_SOURCE.CDP,
                eventAction: content.appointmentId
            });
        }
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.DESKTOP_VIDEO_CHAPTER_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.DESKTOP_VIDEO_CHAPTER_SELECTED,
            eventLabel: content.appointmentId,
            eventAction: "app_id"
        });
    };

    const handleVideoGalleryModalClose = () => {
        setShowVideoGalleryModal(false);
        setVideoGalleryModalOpenConnect(false);
    };
    // Utility function to check if a tab is a gallery tab
    const isGalleryTab = (tab) => [
        GALLERY_TAB_TYPE.exterior,
        GALLERY_TAB_TYPE.interior,
        GALLERY_TAB_TYPE.imperfections,
        GALLERY_TAB_TYPE.allImages,
        GALLERY_TAB_TYPE.highlights
    ].includes(tab);
    return (
        <React.Fragment>
            {isGalleryTab(activeTab) ? (
                <div styleName={"styles.sliderWrapperAllImages"}>
                    <div styleName={"styles.allImagesTabWrapper"}>
                        <div styleName={hideImperfections ? "styles.tabContainerThreeItems" : "styles.tabContainer"}>
                            {desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.allImages ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.allImages)}>All Images</p>}
                            {!desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.exterior ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.exterior)}>Exterior</p>}
                            {!desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.interior ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.interior)}>Interior</p>}
                            {desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.highlights ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.highlights)}>Highlights</p>}
                            <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.carTour ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.carTour)}><img src={VIDEO_TOUR_ICON} /></p>
                            {!hideImperfections && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.imperfections ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.imperfections)}> {imperfectionCount === 0 && "No "}Imperfections {imperfectionCount > 0 && <span>&#40;{imperfectionCount}&#41;</span>} </p>}
                        </div>
                    </div>
                    {(isGalleryTab(activeTab)) && (
                        <Slider {...settingsSlider1}>
                            {(gallery || []).map((image, index) => (
                                <div styleName="styles.premiumItemsWrap">
                                    <img
                                        key={index}
                                        src={fastlyUrl(imageHost, image?.path || mainImage.path, imageTypes.carDetailHeroImage)}
                                        alt={`${getCDPAltText(carFullName)}, ${image?.label || ""}`}
                                        onClick={() => openThreeSixtyView(index)}
                                    />
                                    {image.items && <CarUspContainer slideData={image} />}
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            ) : (
                <div styleName={"styles.outer"}>
                    <div styleName={hideImperfections ? "styles.tabWrapperSmall" : "styles.tabWrapper"}>
                        <div styleName={hideImperfections ? "styles.tabContainerThreeItems" : "styles.tabContainer"}>
                            {/* <p styleName={`styles.tab${activeTab === "threeSixty" ? " styles.tabActive" : ""}`} onClick={() => handleTabClick("threeSixty")}> <img src={threeSixty} /> </p> */}
                            {desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.allImages ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.allImages)}>All Images</p>}
                            {!desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.exterior ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.exterior)}>Exterior</p>}
                            {!desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.interior ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.interior)}>Interior</p>}
                            {desktopPremiumFeaturesVariant && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.highlights ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.highlights)}>Highlights</p>}
                            <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.carTour ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.carTour)}><img src={VIDEO_TOUR_ICON} /></p>
                            {!hideImperfections && <p styleName={`styles.tab${activeTab === GALLERY_TAB_TYPE.imperfections ? " styles.tabActive" : ""}`} onClick={() => handleTabClick(GALLERY_TAB_TYPE.imperfections)}> {imperfectionCount === 0 && "No "}Imperfections {imperfectionCount > 0 && <span>&#40;{imperfectionCount}&#41;</span>} </p>}
                        </div>
                    </div>
                    <div styleName={"styles.sliderWrapper"}>
                        {activeTab === GALLERY_TAB_TYPE.carTour && (
                            <React.Fragment>
                                <Slider
                                    {...carTourSliderSettings}
                                    ref={carTourSliderRef}
                                >
                                    {
                                        content?.carTourData?.chapters?.map((item, idx) => (
                                            <div
                                                onClick={(e) => handleCarTourNudgeClick(e, idx)}
                                                styleName={"styles.imageWrapper"}
                                                key={idx}
                                            >
                                                <img src={carTourIndex === idx ? item.thumbnailUrl : item.thumbnailUrl} />
                                                <div styleName={"styles.videoIconOverlay"}>
                                                    <img src={VideoIcon} alt="Video Icon" />
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Slider>
                                <div styleName={"styles.thumbnailWrapper"}>
                                    {
                                        content?.carTourData?.chapters.map((item, idx) => (
                                            <div styleName={`styles.thumbnail${carTourIndex === idx ? " styles.thumbnailActive" : ""}`} key={idx}>
                                                <div onClick={() => handleThumbnailClick(idx)} styleName={"styles.tumbnailImage"}>
                                                    <img src={item.circularThumbnailUrl} />
                                                </div>
                                                <p styleName={`${carTourIndex === idx ? "styles.chapterTitleFooterActive" : "styles.chapterTitleFooter"}`}>{item?.label}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </React.Fragment>

                        )}
                    </div>
                </div>
            )}
            {(isGalleryTab(activeTab)) && (
                <div styleName="styles.sliderWrapperBottom">
                    <Slider {...settingsSlider2}>
                        {(gallery || []).map(((item, index) => {
                            // Picking a thumbnail is a jump to that image, never a step into the tour.
                            // The click reaches this div before it bubbles to react-slick's focusOnSelect.
                            return (<div key={item?.path} styleName="styles.slider2ImageWrapper" onClick={() => { programmaticGalleryTarget.current = index; }}>
                                <img
                                    src={fastlyUrl(imageHost, item?.path || mainImage.path, imageTypes.spinCarZoomable)}
                                    alt={item?.label}
                                />
                                {<div styleName={`${item.key === GALLERY_TAB_TYPE.highlights ? "styles.sliderOverlay" : ""} ${activeIndex === index ? "styles.slider2ActiveState" : ""}`} />}
                                {item.key === GALLERY_TAB_TYPE.highlights && <img src={fastlyUrl(brandImageHost, item.overlayImage)} styleName="styles.sliderOverlayIcon" />}
                            </div>);
                        }

                        ))}
                    </Slider>
                </div>
            )}
            {
                showVideoGalleryModal && <VideoGallerySliderModal
                    videoUrl={content?.carTourData?.videoPlayerUrl}
                    chapters={content?.carTourData?.chapters}
                    footer={<></>}
                    source={PAGE_SOURCE.CDP}
                    showModal={showVideoGalleryModal}
                    onClose={handleVideoGalleryModalClose}
                    initialChapterIndex={carTourIndex}
                    calculatorRef={calculatorRef}
                    scrollToSection={scrollToSection}
                    isFetchingOrderDetails={isFetchingOrderDetails}
                    isKbbShown={isKbbShown}
                    handleKbbModal={handleKbbModal}
                    ctaProps={ctaProps}
                    step={step}
                />
            }
        </React.Fragment>
    );
};

VideoCatalogCdpHeroslider.propTypes = {
    content: PropTypes.object,
    openGalleryPopUp: PropTypes.func,
    imageHost: PropTypes.string,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    isFetchingOrderDetails: PropTypes.bool,
    isKbbShown: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    ctaProps: PropTypes.object,
    setVideoGalleryModalOpenConnect: PropTypes.func,
    step: PropTypes.object,
    userTradeInData: PropTypes.object,
    isUserZeroDpVariant: PropTypes.bool,
    desktopPremiumFeatures: PropTypes.object,
    config: PropTypes.object,
    hideImperfectionsDesktop: PropTypes.object
};

export default VideoCatalogCdpHeroslider;
